import { ChartOfAccountsTemplateUploadSource } from "@common/constants/domains/accounting/chartOfAccountsTemplateAccount";
import type { InstitutionKey } from "@design-system/InstitutionIcon/InstitutionIcon";

export const QUICKBOOKS_CONNECTION_SOURCE = "quickbooksConnection";

export type ChartOfAccountsTemplateImportSource =
    | ChartOfAccountsTemplateUploadSource
    | typeof QUICKBOOKS_CONNECTION_SOURCE;

export interface ChartOfAccountsTemplateUploadSourceConfig {
    source: ChartOfAccountsTemplateUploadSource;
    label: string;
    fileTypesLabel: string;
    accept: string[];
}

export interface ExportUploadSourceConfig extends ChartOfAccountsTemplateUploadSourceConfig {
    pickerLabel: string;
    institution: InstitutionKey;
}

export const QUICKBOOKS_CONNECTION_OPTION = {
    choice: QUICKBOOKS_CONNECTION_SOURCE,
    label: "Connect QuickBooks Online",
    tooltip:
        "Sign in to QuickBooks and Kick imports your accounts directly. No file needed.",
    institution: "quickbooks" as const,
};

export const EXPORT_UPLOAD_SOURCES: ExportUploadSourceConfig[] = [
    {
        source: ChartOfAccountsTemplateUploadSource.quickBooksOnline,
        label: "QuickBooks Online",
        pickerLabel: "QuickBooks Online export",
        institution: "quickbooks",
        fileTypesLabel: ".csv",
        accept: [".csv"],
    },
    {
        source: ChartOfAccountsTemplateUploadSource.quickBooksDesktop,
        label: "QuickBooks Desktop",
        pickerLabel: "QuickBooks Desktop export",
        institution: "quickbooks",
        fileTypesLabel: ".xlsx or .xls",
        accept: [".xlsx", ".xls"],
    },
    {
        source: ChartOfAccountsTemplateUploadSource.xero,
        label: "Xero",
        pickerLabel: "Xero export",
        institution: "xero",
        fileTypesLabel: ".csv or .xlsx",
        accept: [".csv", ".xlsx"],
    },
];

export function getExportUploadSourceTooltip({
    fileTypesLabel,
    label,
}: ExportUploadSourceConfig) {
    return `Upload the ${fileTypesLabel} file you exported from ${label}.`;
}

export const KICK_TEMPLATE_UPLOAD_SOURCE: ChartOfAccountsTemplateUploadSourceConfig =
    {
        source: ChartOfAccountsTemplateUploadSource.kickTemplate,
        label: "Kick",
        fileTypesLabel: ".xlsm, .xlsx or .csv",
        accept: [".xlsm", ".xlsx", ".csv"],
    };

export const KICK_TEMPLATE_FILENAME = "kick-coa-template.xlsm";
export const KICK_TEMPLATE_DOWNLOAD_URL = `/downloads/${KICK_TEMPLATE_FILENAME}`;

const UPLOAD_SOURCES: ChartOfAccountsTemplateUploadSourceConfig[] = [
    ...EXPORT_UPLOAD_SOURCES,
    KICK_TEMPLATE_UPLOAD_SOURCE,
];

export function getUploadSourceConfig(
    source: ChartOfAccountsTemplateUploadSource,
): ChartOfAccountsTemplateUploadSourceConfig {
    const config = UPLOAD_SOURCES.find((entry) => entry.source === source);
    if (!config) {
        throw new Error(`Unsupported upload source: ${source}`);
    }
    return config;
}
